import { takeLeading, call, put } from "redux-saga/effects";
import {
  studentsSetAll,
  studentAddOne,
  studentUpdateOne,
  studentRemoveOne,
  removeChosenStudent,
  studentsSetConflicts,
  studentsSetConflictsLoading,
  studentsSetConflictsCheckedAt,
} from "../slices/students.slice.js";
import { removeStudentFromEvents } from "../slices/events.slice";

import { loadingEdit, errorEdit, successEdit } from "../slices/status.slice";
import { studentsService } from "../../services";
import { modalEdit, contentEdit } from "../slices/modal.slice.js";

export function* getAll(action) {
  yield put(loadingEdit(true));
  try {
    const response = yield call(studentsService.getAll, action.query || {});
    yield put(studentsSetAll(response.data));
  } catch (error) {
    if (error.response) {
      yield put(errorEdit(error.response.data.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* addOne(action) {
  yield put(loadingEdit(true));
  try {
    const response = yield call(studentsService.create, action.payload);
    yield put(
      studentAddOne(response.data.student)
    );
    yield put(successEdit("New student has been created"));
  } catch (error) {
    console.log(error);
    if (error.response) {
      yield put(errorEdit(error.response.data.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* updateOne(action) {
  yield put(loadingEdit(true));
  try {
    const response = yield call(studentsService.update, action.payload);
    yield put(studentUpdateOne({
      studentId: action.payload.studentId,
      ...response.data.student
    }));
    yield put(removeChosenStudent());
    yield put(contentEdit("The student has been updated"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      yield put(errorEdit(error.response.data.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* removeOne(action) {
  yield put(loadingEdit(true));
  try {
    yield call(studentsService.delete, {
      studentId: action.payload.studentId,
      userId: action.payload.userId,
    });
    yield put(studentRemoveOne(action.payload.studentId));
    yield put(removeChosenStudent());
    yield put(removeStudentFromEvents(action.payload.studentId));
    yield put(contentEdit("The student has been deleted"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      yield put(errorEdit(error.response.data.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* checkConflicts(action) {
  yield put(studentsSetConflictsLoading(true));
  try {
    const response = yield call(studentsService.checkConflicts, action.query || {});
    yield put(studentsSetConflicts(response.data || []));
    yield put(studentsSetConflictsCheckedAt(new Date().toISOString()));
    if (response.data && response.data.length === 0) {
      yield put(successEdit("No overlapping schedules detected"));
    }
  } catch (error) {
    if (error.response) {
      yield put(errorEdit(error.response.data.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(studentsSetConflictsLoading(false));
  }
}

export default function* watchStudentsSaga() {
  yield takeLeading("STUDENTS_GET_ALL", getAll);
  yield takeLeading("STUDENT_ADD_ONE", addOne);
  yield takeLeading("STUDENT_UPDATE_ONE", updateOne);
  yield takeLeading("STUDENT_REMOVE_ONE", removeOne);
  yield takeLeading("STUDENTS_CHECK_CONFLICTS", checkConflicts);
}


